export default __webpack_public_path__ + "static/media/19.8c47fa02.wav";